import React, { useEffect, useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";
import { getSubdomainPath } from "../../utils/helpers";

function SidebarAddClass() {
  document.getElementById("left_sidebar").classList.toggle("sidebar_sec");
}

const Search = (props) => {

  const { keyword, setKeyword, setManters, manters, setAllManters, allManters } = props;

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const allMantersData = params.get('is_available') ? params.get('is_available') : 'all'
  const mantersData = params.get('direction') ? params.get('direction') : 'asc'
  const [boardExperience, setBoardExperience] = useState([]);
  const [boardEntityType, setBoardEntityType] = useState([]);
  const years_of_board_experienceData = params.get("years_of_board_experience") || "";
  const years_of_experienceData = params.get("years_of_experience") || "";
  const boardEntityTypeData = params.get("board_entity_type") || "";
  const [setting, setSetting] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await agent.get(API.SETTING);
        setSetting(response.data.data);
      } catch (error) {
        console.error("Error fetching settings:", error);
      }
    };

    fetchSettings();
  }, []);

  const handleClickSearch = (e) => {
    e.preventDefault()
    params.set("keyword", keyword);

    if (params.get("page") > 1) {
      params.set("page", 1);
    }
    history(`/mentors?${params.toString()}`);
  };

  useEffect(() => {
    const fetchBoardExperience = async () => {
      try {
        const res = await agent.get(`${API.GET_BOARD_EXPERIENCE}?role_id=Mentor`);
        setBoardExperience(res.data.data);
      } catch (error) {
        console.error(error);
      }
    };

    const fetchBoardEntityType = async () => {
      try {
        const res = await agent.get(API.GET_BOARD_ENTITY_TYPE_EXPERIENCE);
        setBoardEntityType(res.data.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchBoardEntityType();
    fetchBoardExperience();
  }, []);

  const history = useNavigate();

  const handleClickFilter = (value) => {
    setManters(value)
    const params = new URLSearchParams(location.search);
    params.set("sort", "first_name");
    params.set("direction", value);
    if (params.get("page") > 1) {
      params.set("page", 1);
    }
    history(`/mentors?${params.toString()}`);
  };
  const handleClickFilterAvailable = (value) => {
    setAllManters(value)
    const params = new URLSearchParams(location.search);
    params.set("is_available", value);
    if (params.get("page") > 1) {
      params.set("page", 1);
    }
    history(`/mentors?${params.toString()}`);
  };

  const handleClickYears_of_board_experience = (value) => {
    const params = new URLSearchParams(location.search);

    if (value) {
      params.set("years_of_board_experience", value);
    } else {
      params.delete("years_of_board_experience");
    }

    params.set("page", 1);

    history(`/mentors?${params.toString()}`);
  };

  const handleClickYears_of_experience = (value) => {
    const params = new URLSearchParams(location.search);

    if (value) {
      params.set("years_of_experience", value);
    } else {
      params.delete("years_of_experience");
    }

    params.set("page", 1);

    history(`/mentors?${params.toString()}`);
  };

  const handleClickBoardEntityType = (value) => {
    const params = new URLSearchParams(location.search);

    if (value) {
      params.set("board_entity_type", value);
    } else {
      params.delete("board_entity_type");
    }

    params.set("page", 1);

    history(`/mentors?${params.toString()}`);
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const keywordData = params.get('keyword') ? params.get('keyword') : ''
    setKeyword(keywordData)
  }, []);

  const subDomainPath = getSubdomainPath();

  return (
    <div className="mentor_form mb-4">
      <button
        onClick={SidebarAddClass}
        className="d-block d-md-none sidebar_toggle_btn mb-3"
      >
        <button className="btn">
          <i className="fas fa-bars"></i> Filter
        </button>
      </button>
      <Row className="align-items-center g-2 flex-wrap">
        <Col md="2" className="flex-grow-1">
          <div className="search position-relative mb-2 mb-md-0">
            <Form>
              <Form.Control
                type="text"
                value={keyword}
                placeholder="Search by name, country, organization or designation"
                onChange={(event) => {
                  setKeyword(event.target.value);
                }}
              ></Form.Control>
              <Button type='submit' onClick={(e) => handleClickSearch(e)} style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)" }}>
                {/* <img
                src={imgPath + "search.png"}
                alt="search"
              /> */}
                <i className="fas fa-search" style={{ color: "var(--themeBlueHover)" }}></i>
              </Button>
            </Form>
          </div>
        </Col>
        {setting?.mentors_experience_search_enable == "1" && (
          subDomainPath === "siddev" || subDomainPath === "siduat" || subDomainPath === "sid" ? (
            <Col md={2}>
              <Form.Control
                as="select"
                name="years_of_board_experience"
                value={years_of_board_experienceData || ""}
                onChange={(e) => {
                  handleClickYears_of_board_experience(e.target.value);
                }}
              >
                <option value="">Select Experience Level</option>

                {boardExperience?.map((item) => (
                  <option value={item.id} key={item.id}>
                    {item.title}
                  </option>
                ))}
              </Form.Control>
            </Col>
          ) : (
            <Col md={2}>
              <Form.Control
                type="text"
                name="years_of_experience"
                placeholder="Years of Experience"
                value={years_of_experienceData || ""}
                onChange={(e) => {
                  handleClickYears_of_experience(e.target.value);
                }}
              />
            </Col>
          )
        )}
        {setting?.mentors_board_search_enable == "1" &&
          <Col md="2" className="flex-grow-1">
            <Form.Control
              as="select"
              name="board_entity_type"
              value={boardEntityTypeData || ""}
              onChange={(e) => {
                handleClickBoardEntityType(e.target.value);
              }}
            >
              <option value="">Select Board Entity Type</option>

              {boardEntityType?.map((item) => (
                <option value={item.id} key={item.id}>
                  {item.title}
                </option>
              ))}
            </Form.Control>
          </Col>
        }
        <Col md="2" className="flex-grow-1">
          <Form.Control
            as="select"
            name="order"
            value={manters || mantersData}
            onChange={(e) => {
              handleClickFilter(e.target.value);
            }}
          >
            <option value="asc">Mentor (A-Z)</option>
            <option value="desc">Mentor (Z-A)</option>
          </Form.Control>
        </Col>
        <Col md="2" className="flex-grow-1">
          <Form.Control
            as="select"
            name="availablity"
            value={allManters || allMantersData}
            onChange={(e) => {
              handleClickFilterAvailable(e.target.value);
            }}
          >
            <option value="all">All Mentors</option>
            <option value="yes">Available</option>
            <option value="no">Unavailable</option>
          </Form.Control>
        </Col>
      </Row>
    </div>
  );
};

Search.propTypes = {
  keyword: PropTypes.string.isRequired,
  setKeyword: PropTypes.func.isRequired,
  manters: PropTypes.string.isRequired,
  setManters: PropTypes.func.isRequired,
  allManters: PropTypes.string.isRequired,
  setAllManters: PropTypes.func.isRequired,
};

export default Search;
